import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {TranslatePipe} from '@brunata-angular/util';
import {CheckboxGroupComponent} from '@brunata-angular/ui';
import {ExportNoteComponent} from '../../shared/ui/export-note/export-note.component';
import {SystemRow, SystemsTableComponent} from './systems-table.component';
import {StepCardDirective} from '../step-card/step-card.directive';
import {stepLabels} from '../step-card/step-labels.model';

@Component({
    selector: 'app-systems-step',
    standalone: true,
    providers: [
        stepLabels(
            'customizedexports_export_step_systems_title',
            'customizedexports_export_step_systems_hint',
        ),
    ],
    hostDirectives: [{directive: StepCardDirective, inputs: ['titleKey', 'hintKey']}],
    imports: [
        TranslatePipe,
        ReactiveFormsModule,
        CheckboxGroupComponent,
        ExportNoteComponent,
        SystemsTableComponent,
    ],
    template: `
        @if (noSuperTypesSelected()) {
            <app-export-note icon="bi-info-circle-fill">
                {{
                    'customizedexports_export_step_systems_no_super_types'
                        | translate: 'online' : 'export'
                }}
            </app-export-note>
        } @else if (systems() === undefined) {
            <p class="text-muted small mb-0">
                {{
                    'customizedexports_export_step_systems_loading' | translate: 'online' : 'export'
                }}
            </p>
        } @else if (systems() === null) {
            <app-export-note icon="bi-exclamation-triangle" tone="muted">
                {{
                    'customizedexports_export_step_systems_load_error'
                        | translate: 'online' : 'export'
                }}
            </app-export-note>
        } @else if (systems(); as rows) {
            @if (offersAutoInclude()) {
                <div class="border bg-white p-3 mb-3">
                    <app-checkbox-group
                        [label]="
                            'customizedexports_export_step_systems_auto_include_label'
                                | translate: 'online' : 'export'
                        "
                        [description]="
                            'customizedexports_export_step_systems_auto_include_description'
                                | translate: 'online' : 'export'
                        "
                        [formControl]="autoIncludeControl()" />
                </div>
            }

            @if (rows.length === 0) {
                <app-export-note icon="bi-info-circle-fill">
                    {{
                        'customizedexports_export_step_systems_empty'
                            | translate: 'online' : 'export'
                    }}
                </app-export-note>
            } @else {
                <app-systems-table
                    [systems]="rows"
                    [selectedSystemIds]="selectedSystemIds()"
                    (systemToggled)="systemToggled.emit($event)"
                    (systemsSelected)="systemsSelected.emit($event)"
                    (systemsDeselected)="systemsDeselected.emit($event)"
                    (cleared)="cleared.emit()" />
            }
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SystemsStepComponent {
    readonly systems = input.required<ReadonlyArray<SystemRow> | null | undefined>();
    readonly noSuperTypesSelected = input.required<boolean>();
    readonly offersAutoInclude = input.required<boolean>();
    readonly autoIncludeControl = input.required<FormControl<boolean>>();
    readonly selectedSystemIds = input.required<ReadonlyArray<string>>();

    readonly systemToggled = output<string>();
    readonly systemsSelected = output<string[]>();
    readonly systemsDeselected = output<string[]>();
    readonly cleared = output<void>();
}
